import React, { useState, useRef } from 'react';

/**
 * HorizontalCarousel - Clean carousel style
 */
export const HorizontalCarousel = ({ children, itemWidth = 320 }) => {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const checkScrollPosition = () => {
    if (scrollContainerRef.current) {
      // Batch DOM reads to prevent forced reflow
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      // Use requestAnimationFrame to batch DOM writes after reads
      requestAnimationFrame(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollBy({ left: direction === 'left' ? -itemWidth : itemWidth, behavior: 'smooth' });
          setTimeout(checkScrollPosition, 300);
        }
      });
    }
  };

  React.useEffect(() => {
    checkScrollPosition();
    window.addEventListener('resize', checkScrollPosition);
    return () => window.removeEventListener('resize', checkScrollPosition);
  }, [children]);

  return (
    <div className="relative" data-testid="horizontal-carousel">
      {showLeftArrow && (
        <button onClick={() => scroll('left')} className="hidden md:flex absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white shadow-md border border-[#E8E4DF] hover:shadow-lg hover:border-[#D4A853] transition-all" aria-label="Previous" data-testid="carousel-prev">
          <svg className="w-5 h-5 text-[#1E3A5F]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
        </button>
      )}
      {showRightArrow && (
        <button onClick={() => scroll('right')} className="hidden md:flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white shadow-md border border-[#E8E4DF] hover:shadow-lg hover:border-[#D4A853] transition-all" aria-label="Next" data-testid="carousel-next">
          <svg className="w-5 h-5 text-[#1E3A5F]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
        </button>
      )}
      <div ref={scrollContainerRef} onScroll={checkScrollPosition} className="overflow-x-auto scrollbar-hide scroll-smooth" style={{ scrollbarWidth: 'none' }}>
        <div className="flex gap-5 py-2 px-1">{children}</div>
      </div>
    </div>
  );
};
